<script>
import { fandomBasicMixin, fandomExtendedMixin } from "src/modules/fandom_mixins_module.js";
import { vodafoneLabBasicMixin } from '../../modules/vodafone_lab_mixins_module.js';
import Flickity from "flickity";
import { get } from "lodash";

export default {
  // useless comment for assets recompile
  mixins: [fandomBasicMixin, fandomExtendedMixin, vodafoneLabBasicMixin],
  data: function () {
    return {
      carousel: undefined
    };
  },
  mounted() {
    Vue.nextTick(() => {
      if (Fandom.exists(this.content.children)) {
        this.carousel = new Flickity(this.$refs["flickity-carousel"], {
          draggable: true,
          prevNextButtons: true,
          pageDots: true,
          cellAlign: "left",
          groupCells: true,
          contain: true,
          arrowShape: { x0: 20, x1: 60, y1: 45, x2: 60, y2: 40, x3: 25 }
        });
      }
    });
  },
  computed: {
    headingAlignment() {
      return get(this, ["content", "heading_align"], "left");
    },
    showDots() {
      if (this.isMobile) {
        return this.childrenCount > 1;
      }
      const showDesktopDots = !get(this, ["content", "hide_dots"], false);
      return showDesktopDots && this.childrenCount > 4;
    },
    childrenCount() {
      return get(this, ["content", "children"], []).length;
    },
    isMobile() {
      return globalState.viewport.xs || globalState.viewport.sm;
    },
    aspectRatioClass() {
      const aspectRatio = this.content.aspect_ratio;
      if (aspectRatio) {
        return aspectRatio.startsWith("ar-") ? aspectRatio : `ar-${aspectRatio}`
      } else {
        return "ar-2by3";
      }
    }
  },
  methods: {
    expandUrl: Fandom.expandUrl,
    getBackgroundUrl: Fandom.getBackgroundUrl,
    getTarget: Fandom.getTarget,
  }
};
</script>

<template>
  <div
    v-easyadmin="easyadminId"
    :class="contentType"
    v-if="isContentVisibleToUser()"
    :id="content.name"
    class="themed-item"
    :style="theme"
  >
    <div stripe-carousel-collections-component>
      <stripe-header
        class="px-3 px-md-0"
        :content="content"
        :align="headingAlignment"
        :col="content.heading_width"
        :opt-container-content="containerContent"
        v-if="content.title || content.description"
        >
      </stripe-header>
      <div class="container pb-md-5 pb-4">
        <div class="row py-3 py-sm-4">
          <div class="col-12 px-0">
            <div class="flickity-carousel mx-0" ref="flickity-carousel">
              <div
                v-for="child in content.children"
                class="flickity-carousel-item tile-link"
                :class="{'tile-contacts': content.skin == 'contacts'}"
              >
                <div class="w-100" :class="aspectRatioClass">
                  <div class="pl-3 px-md-1" :class="{'position-absolute-center': aspectRatioClass != 'ar-none'}">
                    <component :forceMobileThumbnail="true" class="w-100 h-100" :is="getContent(child).layout" :content="getContent(child)"></component>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 text-center pt-5" v-if="content.button">
            <a class="btn btn-primary" :href="applyContextToUrl(content.button.url)" :title="content.button.title" :target="getTarget(content.button)">
              {{content.button.title}}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
[stripe-carousel-collections-component] {
  @include media-breakpoint-down(sm) {
    > .container {
      max-width: 100%;
    }
  }

  .flickity-prev-next-button {
    &[disabled] {
      display: none;
    }

    &.previous{
      left: -55px;
    }

    &.next{
      right: -55px;
    }

    @include media-breakpoint-down(sm) {
      display: none !important;
    }
  }

  .flickity-page-dots {
    bottom: -30px;

    .dot {
      width: 12px;
      height: 12px;

      &.is-selected {
        background: $red;
      }
    }

    .dot:first-child:nth-last-child(1) {
      display: none;
    }
  }

  .flickity-carousel-item {
    width: 25%;

    @include media-breakpoint-down(md) {
      width: 50%;
    }

    @include media-breakpoint-down(sm) {
      width: 75%;
    }

    &.tile-contacts {
      @include media-breakpoint-down(xl) {
        width: 30%;
      }

      @include media-breakpoint-down(lg) {
        width: 40%;
      }

      @include media-breakpoint-down(md) {
        width: 50%;
      }

      @include media-breakpoint-down(xs) { 
        width: 80%;
      }
    }
  }
}
</style>
